import { Component, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'password-validator',
  templateUrl: './password-validator.component.html'
})
export class PasswordValidatorComponent {

  @Input() public password: FormControl;
  @Input() public form: FormGroup;

  constructor() {
  }

}
